import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Batch } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';
export class BatchService {
   async getBatch(batchId: number) {
      const response = await http.get<Batch>(`/batches/${batchId}`);
      return response.data;
   }
   async getBatches(query?: LocationQuery) {
      const response = await http.get<ApiResource<Batch>>(`/batches`, { params: { ...query } });
      return response.data;
   }
}
